export default "__VITE_ASSET__D3vd0eZU__"